let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ib1Bj")).then(() => parcelRequire('cpvId'));